import Statsig from "statsig-js";
import {useExperiment, useStatsigClient} from '@statsig/react-bindings';

const STATSIG_CLIENT_KEY = process.env.REACT_APP_STATSIG_CLIENT_KEY || "";

const STRIPE_LINK_GATE = {
  name: "four_month_stripe_links",
} as const;

const STRIPE_EXPERIMENT_NAME = {
  name: "quiz_split_test_trial",
} as const;

const getVersionNumber = () => {
  const experiment = STRIPE_LINK_GATE;
  
  //const config = Statsig.checkGateWithExposureLoggingDisabled(experiment.name);
  return "v 2.6.11";
};

const checkStripeGate = () => {
  return true;
};


const checkStripeExperiment = () => {
  
 
  return true;
};

export {
  STATSIG_CLIENT_KEY,
  STRIPE_LINK_GATE,
  STRIPE_EXPERIMENT_NAME,
  getVersionNumber,
  checkStripeGate,
  checkStripeExperiment,
};
